<div class="pt-8">
  <p class="small text-red">
    <em>{{ text }}</em>
  </p>
</div>
